// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__35ODy","info":"PatientInfo_info__3ZUeN"};